var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        // eslint-disable-next-line
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
// material-ui
var styles_1 = require("@mui/material/styles");
var material_1 = require("@mui/material");
// ==============================|| CUSTOM SUB CARD ||============================== //
var SubCard = react_1.default.forwardRef(function (_a, ref) {
    // eslint-disable-next-line
    var children = _a.children, className = _a.className, content = _a.content, contentClass = _a.contentClass, darkTitle = _a.darkTitle, secondary = _a.secondary, _b = _a.sx, sx = _b === void 0 ? {} : _b, _c = _a.contentSX, contentSX = _c === void 0 ? {} : _c, title = _a.title, others = __rest(_a, ["children", "className", "content", "contentClass", "darkTitle", "secondary", "sx", "contentSX", "title"]);
    var theme = (0, styles_1.useTheme)();
    return ((0, jsx_runtime_1.jsxs)(material_1.Card, __assign({
        ref: ref, sx: __assign({
            border: '1px solid', borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.primary.light, ':hover': {
                boxShadow: theme.palette.mode === 'dark' ? '0 2px 14px 0 rgb(33 150 243 / 10%)' : '0 2px 14px 0 rgb(32 40 45 / 8%)'
            }
        }, sx)
    }, others, {
        children: [!darkTitle && title && ((0, jsx_runtime_1.jsx)(material_1.CardHeader, { sx: { p: 2.5 }, title: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h5" }, { children: title })), action: secondary })), darkTitle && title && ((0, jsx_runtime_1.jsx)(material_1.CardHeader, { sx: { p: 2.5 }, title: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ variant: "h4" }, { children: title })), action: secondary })), title && ((0, jsx_runtime_1.jsx)(material_1.Divider, {
            sx: {
                opacity: 1,
                borderColor: theme.palette.mode === 'dark' ? theme.palette.dark.light + 15 : theme.palette.primary.light
            }
        })), content && ((0, jsx_runtime_1.jsx)(material_1.CardContent, __assign({ sx: __assign({ p: 2.5 }, contentSX), className: contentClass || '' }, { children: children }))), !content && children]
    })));
});
SubCard.defaultProps = {
    content: true
};
exports.default = SubCard;